import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazySecurityConfigurationPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SecurityConfigurationContainer" */ '../src/SecurityConfiguration/SecurityConfigurationPage.tsx'
			)
		).SecurityConfigurationPage,
});
